import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePublicNavBar } from './NavBar';
import ForgottenPassword from '../common/components/ForgottenPassword';

export const AngularForgottenPassword = () => <ForgottenPassword></ForgottenPassword>
export const ReactForgottenPassword = () => {
    const { t } = useTranslation();
    const { setTitle } = usePublicNavBar();

    useEffect(() => setTitle(t('forgottenPassword')), [t, setTitle]);

    return <ForgottenPassword></ForgottenPassword>
}